// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"S3-z","displaySixCardTiles":"T3-z"};